/* @flow */

import React, { Component } from 'react';
import Config from './config';


export default class TabBar extends Component {
  render() {
    var onClick = this.props.onClick;
    var tabs = Config.tabList.map(function (tab) {
      return <td key={tab.id} onClick={onClick.bind(this, tab)}><div className="white_box_with_black_frame">{tab.name}</div></td>;
      //return <li key={tab.id} onClick={onClick.bind(this, tab)}>{tab.name}</li>;
    });
    return (
      <table className="TabBar no-print" cellPadding="5" cellSpacing="0" width="100%">
        <tbody><tr>
          {tabs}
        </tr></tbody>
      </table>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/tabBar.js
 **/